import styled from "styled-components";

export const WeatherWrapper = styled.div`
  margin: 4rem 0;
`;
